import { render, staticRenderFns } from "./V_Ongoing_PolygonsMap_List.vue?vue&type=template&id=4e98ffb2&scoped=true&"
import script from "./V_Ongoing_PolygonsMap_List.vue?vue&type=script&lang=js&"
export * from "./V_Ongoing_PolygonsMap_List.vue?vue&type=script&lang=js&"
import style0 from "./V_Ongoing_PolygonsMap_List.vue?vue&type=style&index=0&id=4e98ffb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e98ffb2",
  null
  
)

export default component.exports